import React from 'react';
import { useTaMetrics } from 'services/DashboardApi/queries/useTaMetrics';
import { useCrmMetrics } from 'services/DashboardApi/queries/useCrmMetrics';
import { ICrmMetricsRequest, ITaMetricsRequest } from 'services/DashboardApi/types';
import { TaMetricsData } from './TaMetricsData';
import { CrmMetricsKpisData } from './CrmMetricsKpisData';
import { validateMonthRange } from 'ui/MonthPicker/MonthRangePicker';
import { ErrorBar } from 'ui/NetworkStatusBar';
import { dateToYearMonth } from '../helpers';

interface ICrmMetricsProps {
  salesUserId: string | undefined;
  dateFrom: string;
  dateTo: string;
}

export const CrmMetrics: React.FC<ICrmMetricsProps> = ({ salesUserId, dateFrom, dateTo }) => {
  const { year: startYear, month: startMonth } = dateToYearMonth(dateFrom);
  const { year: endYear, month: endMonth } = dateToYearMonth(dateTo);

  const taMetricsRequest: ITaMetricsRequest = {
    startYear,
    startMonth,
    endYear,
    endMonth,
    salesUserUuid: salesUserId,
  };

  const crmMetricsRequest: ICrmMetricsRequest = {
    startYear,
    startMonth,
    endYear,
    endMonth,
    salesUserUuid: salesUserId,
  };

  const { taMetricsData, isLoadingTaMetricsData, isErrorTaMetricsData } = useTaMetrics(taMetricsRequest);
  const { crmMetricsData, isLoadingCrmMetrics, isErrorCrmMetrics } = useCrmMetrics(crmMetricsRequest);

  const errorMessage = validateMonthRange({ monthFrom: dateFrom?.slice(0, 7), monthTo: dateTo?.slice(0, 7) }, 12); // max period in months allowed is 12
  const showError = errorMessage != null && errorMessage.length > 0;
  if (showError) {
    return (
      <div className="w-full flex justify-center items-center mt-5 mb-5">
        <ErrorBar message={errorMessage} showCta={false} />
      </div>
    );
  }

  return (
    <div className="crm-dashboard-crm-metrics px-[30px] py-[40px]">
      <p className="font-noe-display text-[26px] leading-33px text-black font-normal m-0 mb-[20px]">CRM Metrics</p>

      <CrmMetricsKpisData
        crmMetricsData={crmMetricsData}
        isLoadingCrmMetrics={isLoadingCrmMetrics}
        isErrorCrmMetrics={isErrorCrmMetrics}
      />

      <TaMetricsData
        taMetricsData={taMetricsData}
        isLoadingTaMetricsData={isLoadingTaMetricsData}
        isErrorTaMetricsData={isErrorTaMetricsData}
      />
    </div>
  );
};
